import { Injectable } from '@angular/core';
import { DefaultService } from 'src/app/core/framework/default-service';
import { TipoDeBaixaDeProduto } from './model/tipo-de-baixa-de-produto.model';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class TipoDeBaixaDeProdutoService extends DefaultService<TipoDeBaixaDeProduto> {

  static url = '/api/farmacia/tipodebaixadeproduto/v1/tipodebaixadeproduto';

  constructor(
    public httpClient: HttpClient,
    public errorHandlerService: ErrorHandlerService
  ) {
    super(httpClient, errorHandlerService, TipoDeBaixaDeProdutoService.url);
  }
}
